import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { contentCustomizationBackend } from './content-customization.backend';
import { contentCustomizationReducer } from './content-customization.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('contentCustomization', contentCustomizationReducer),
    BackendModule.forFeature(
      'contentCustomization',
      contentCustomizationBackend,
    ),
  ],
})
export class DatastoreContentCustomizationModule {}
